import { SET_TEST_SELECTION } from './types';

export const setTestSelection = testSelection => ({
  type: SET_TEST_SELECTION, testSelection
});
